import { render, staticRenderFns } from "./compareLifeInsurance.vue?vue&type=template&id=5d9cf43c&"
import script from "./compareLifeInsurance.vue?vue&type=script&lang=ts&"
export * from "./compareLifeInsurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports